var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStep = function SvgStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.858305 17.4009C0.37015 16.9128 0.37015 16.1213 0.858305 15.6332L7.49144 9.00005L0.858304 2.36692C0.370148 1.87876 0.370149 1.0873 0.858304 0.599149C1.34646 0.110993 2.13792 0.110993 2.62607 0.599149L10.1431 8.11616C10.6312 8.60432 10.6312 9.39578 10.1431 9.88393L2.62607 17.4009C2.13792 17.8891 1.34646 17.8891 0.858305 17.4009Z",
    fill: "#1D1D1B"
  })));
};
export default SvgStep;